import React from 'react'
import { ChartWrapper } from '../ChartWrapper/ChartWrapper'

export interface TableColumn {
  key: string
  label: string
  render?: (value: any, row: any) => React.ReactNode
}

interface DynamicTableProps {
  title: string
  columns: TableColumn[]
  data: any[]
  emptyMessage?: string
  maxRows?: number
}

export function DynamicTable({
  title,
  columns,
  data,
  emptyMessage = 'Nenhum dado disponível',
  maxRows = 10,
}: DynamicTableProps) {
  const displayData = data.slice(0, maxRows)

  return (
    <div className="row">
      <div className="col-12">
        <ChartWrapper title={title}>
          {displayData.length > 0 ? (
            <div className="table-responsive p-4">
              <table className="table table-row-dashed table-row-gray-300 gy-7">
                <thead>
                  <tr className="fw-semibold fs-6 text-gray-800">
                    {columns.map((column) => (
                      <th className=' text-muted fw-bolder text-uppercase fs-7 text-center' key={column.key}>{column.label}</th>
                    ))}
                  </tr>
                </thead>
                <tbody>
                  {displayData.map((row, index) => (
                    <tr key={row.id || index}>
                      {columns.map((column) => (
                        <td key={`${index}-${column.key}`}  className='text-center text-muted p-2'>
                          {column.render
                            ? column.render(row[column.key], row)
                            : row[column.key] || 'N/A'}
                        </td>
                      ))}
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          ) : (
            <div className="text-center py-5">
              <p className="text-muted">{emptyMessage}</p>
            </div>
          )}
        </ChartWrapper>
      </div>
    </div>
  )
}
